import { Button } from '../../components/ui/button';
import ModalCloseButton from '../../components/generic/ModalCloseButton';
import { Dialog, DialogContent } from '../../components/ui/dialog';
import { useEffect, useState } from 'react';
import { ArrowLineDownIcon, FilePdfIcon, SparkleIcon } from '@phosphor-icons/react';
import downloadAnalysis from '../services/downloadAnalysis';
import { Drawer, DrawerContent } from '../../components/ui/drawer';

export default function DownloadAnalysisModal({
  isOpen,
  onClose,
  testId,
  testTitle,
  packId,
  userId,
  userEmail,
  userToken,
  setdownloadingAnalysisDisable = () => {},
}) {
  const [isTablet, setIsTablet] = useState(true);
  useEffect(() => {
    const checkIfTablet = () => {
      setIsTablet(window.innerWidth > 1024);
    };

    checkIfTablet();
    window.addEventListener('resize', checkIfTablet);
    return () => window.removeEventListener('resize', checkIfTablet);
  }, []);

  const aiReportUrl = `https://quizrr-recommendations.s3.ap-south-1.amazonaws.com/${testId}_${userId}_quizrr_performance_report.pdf`;

  const renderContent = () => {
    return (
      <div className="h-full flex flex-col gap-3 items-center overflow-y-auto">
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-center text-[var(--q3-neutral-default)]">Download Analysis</h2>
          <p className="text-[var(--q3-neutral-light)]">Select which of analysis you'd like to download</p>
        </div>
        <Button
          variant={'outline'}
          className={'w-full rounded-full text-[var(--q3-neutral-default)] text-sm'}
          onClick={() => {
            window.open(aiReportUrl, '_blank')?.focus();
            onClose();
          }}
        >
          <div className="flex flex-row w-full justify-between items-center">
            <div className="flex flex-row items-center gap-2">
              <SparkleIcon size={22} className="text-[var(--q3-accent-normal)]" />
              Quizrr AI Analysis
            </div>
            <ArrowLineDownIcon size={22} className="text-[var(--q3-neutral-default)]" />
          </div>
        </Button>
        <Button
          variant={'outline'}
          className={'w-full rounded-full text-[var(--q3-neutral-default)] text-sm'}
          onClick={() => {
            downloadAnalysis(testId, packId, userId, userToken, setdownloadingAnalysisDisable);
            onClose();
          }}
        >
          <div className="flex flex-row w-full justify-between items-center">
            <div className="flex flex-row items-center gap-2">
              <FilePdfIcon size={22} className="text-[var(--q3-danger-normal)]" />
              Detailed Analysis
            </div>
            <ArrowLineDownIcon size={22} className="text-[var(--q3-neutral-default)]" />
          </div>
        </Button>
      </div>
    );
  };

  if (isTablet) {
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent
          showCloseButton={false}
          className="p-6 w-max bg-[var(--q3-surface-default)] border-0 min-w-[500px] backdrop-blur-sm"
        >
          <div className="relative h-full max-h-[80vh]">
            <ModalCloseButton onClick={onClose} />
            {renderContent()}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={isOpen} onOpenChange={onClose}>
      <DrawerContent showCloseButton={false} className="min-h-[220px] py-0 px-4 backdrop-blur-sm">
        <div className="relative h-full min-h-[220px]">
          <ModalCloseButton onClick={onClose} />
          {renderContent()}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
